import {SYS} from '@/config';

export default SYS == 'staff' ? [{  // 申请单列表
	path: 'apply',
	name: 'm_app_aftersale_apply',
	meta: {
		title: '售后申请单',
		keepAlive: true
	},
	component: () => import('@/pages/staff/aftersales/apply_list')
}, {  // 申请单详情
	path: 'apply/detail',
	meta: {
		title: '售后申请单详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/apply_detail')
}, {  // 工单列表
	path: 'work',
	name: 'm_app_aftersale_order',
	meta: {
		title: '工单',
		keepAlive: true
	},
	component: () => import('@/pages/staff/aftersales/work_list')
}, {  // 工单详情
	path: 'work/detail',
	meta: {
		title: '工单详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/work_detail')
}, {  // 工单编辑
	path: 'work/edit',
	meta: {
		title(route) {
			return route.query.id ? '编辑售后工单' : '创建售后工单';
		}
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/work_edit')
}, {  // 修改售后位置（服务中状态）
	path: 'work/location/edit',
	meta: {
		title: '修改售后位置'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/work_location_edit')
}, {  // 工单日历
	path: 'work/schedule',
	meta: {
		title: '工单日历'
	},
	component: () => import('@/pages/staff/aftersales/work_schedule')
}, {  // 外协招工列表
	path: 'outsource',
	name: 'm_app_out_sourcing_recruit',
	meta: {
		title: '外协招工',
		keepAlive: true
	},
	component: () => import('@/pages/staff/aftersales/outsource_list')
}, {  // 外协招工详情
	path: 'outsource/detail',
	meta: {
		title: '外协招工详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/outsource_detail')
}, {  // 外协招工编辑
	path: 'outsource/edit',
	meta: {
		title: '发起外协招工'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/aftersales/outsource_edit')
}] : [{  // 工单列表
	path: 'work',
	name: 'custom_aftersale_order',
	meta: {
		title: '工单',
		keepAlive: true
	},
	component: () => import('@/pages/client/aftersales/work_list')
}, {  // 工单详情
	path: 'work/detail',
	meta: {
		title: '工单详情'
	},
	props: route => route.query,
	component: () => import('@/pages/client/aftersales/work_detail')
}, {  // 评价列表
	path: 'appraise',
	name: 'custom_order_evaluate',
	meta: {
		title: '服务评价',
		keepAlive: true
	},
	component: () => import('@/pages/client/aftersales/appraise_list')
}, {  // 评价编辑
	path: 'appraise/edit',
	meta: {
		title: '服务评价'
	},
	props: route => route.query,
	component: () => import('@/pages/client/aftersales/appraise_edit')
}];